"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _style = _interopRequireDefault(require("./style.css"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var GroupTable = function GroupTable(props) {
  var data = props.data;
  var _useMemo = (0, _react.useMemo)(function () {
      return {
        total: data.rows.reduce(function (num, item) {
          return num + item.total;
        }, 0)
      };
    }, [data]),
    total = _useMemo.total;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].tableWrapper
  }, /*#__PURE__*/_react["default"].createElement("table", {
    className: (0, _classnames["default"])('table table-condensed', _style["default"].table)
  }, /*#__PURE__*/_react["default"].createElement("thead", null, /*#__PURE__*/_react["default"].createElement("tr", null, /*#__PURE__*/_react["default"].createElement("th", null, "\xA0"), data.columns.map(function (column) {
    return /*#__PURE__*/_react["default"].createElement("th", {
      key: column.code,
      className: "text-center"
    }, column.label);
  }), /*#__PURE__*/_react["default"].createElement("th", {
    className: "text-center"
  }, "TOTAL"))), /*#__PURE__*/_react["default"].createElement("tbody", null, data.rows.map(function (row) {
    return /*#__PURE__*/_react["default"].createElement("tr", {
      key: row.label
    }, /*#__PURE__*/_react["default"].createElement("td", {
      className: (0, _classnames["default"])(row.isOthers && _style["default"].others)
    }, /*#__PURE__*/_react["default"].createElement("b", null, row.label)), data.columns.map(function (column, index) {
      return /*#__PURE__*/_react["default"].createElement("td", {
        key: column.code,
        className: "text-center"
      }, row.values[index]);
    }), /*#__PURE__*/_react["default"].createElement("td", {
      className: "text-center"
    }, /*#__PURE__*/_react["default"].createElement("b", null, row.total)));
  })), /*#__PURE__*/_react["default"].createElement("tfoot", null, /*#__PURE__*/_react["default"].createElement("tr", null, /*#__PURE__*/_react["default"].createElement("td", null, "TOTAL"), data.columns.map(function (column, index) {
    return /*#__PURE__*/_react["default"].createElement("td", {
      key: column.code,
      className: "text-center"
    }, column.total);
  }), /*#__PURE__*/_react["default"].createElement("td", {
    className: "text-center"
  }, /*#__PURE__*/_react["default"].createElement("b", null, total))))));
};
GroupTable.propTypes = {
  data: _propTypes["default"].object
};
var _default = GroupTable;
exports["default"] = _default;